import {
  FormCheckbox,
  FormDropdown,
  FormInput,
  validateNumbers,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import ProductBrowser from 'components/admin/Products/Segments/ProductBrowser'
import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { Field, FieldArray, Fields } from 'redux-form'
import { Grid, Segment, Table } from 'semantic-ui-react'
import DiscountedProductRow from './DiscountedProductRow'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DiscountName from './DiscountName'
import DiscountDates from './DiscountDates'

const i18nkey = 'admin.discounts.details.'

const mapStateToProps = (state, ownProps) => {
  const { products } = state.product
  return { products }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class DiscountProducts extends React.Component {
  constructor(props) {
    super(props)
    this.removeProduct = this.removeProduct.bind(this)
  }

  addProduct(article_number) {
    const { products, array } = this.props
    const product = products.find(
      (product) => product.article_number === article_number,
    )
    if (product) array.push('product_ids', product.id)
  }

  removeProduct(index) {
    const { array } = this.props
    array.remove('product_ids', index)
  }

  getRows({ fields }) {
    const { products } = this.props
    return fields.map((field, index) => (
      <Field
        name={field}
        component={({ input }) => {
          const product =
            (products &&
              products.find((product) => product.id === input.value)) ||
            {}
          return (
            <DiscountedProductRow
              {...{
                key: index,
                index,
                product,
                removeProduct: this.removeProduct,
              }}
            />
          )
        }}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    const options = [
      { value: 'amount', text: I18n.t(i18nkey + 'type_chf') },
      { value: 'percent', text: I18n.t(i18nkey + 'type_percentage') },
    ]

    return (
      <Segment attached className={classNames([dark && 'inverted'])}>
        <Grid stackable>
          <DiscountName/>
          <Grid.Row>
            <Grid.Column width={12}>
              <Field
                name="code"
                component={FormInput}
                label={I18n.t(i18nkey + 'code')}
                placeholder={I18n.t(i18nkey + 'code_placeholder')}
                icon={{ name: 'gift', color: 'orange', size: 'large' }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              <Field
                component={FormDropdown}
                validate={validateRequired}
                name="kind"
                label={I18n.t(i18nkey + 'kind')}
                options={options}
                selection
                required
              />
            </Grid.Column>
            <Grid.Column width={3} verticalAlign="middle">
              <Field
                component={FormInput}
                validate={[validateNumbers, validateRequired]}
                name="value"
                label={I18n.t(i18nkey + 'value')}
                placeholder={I18n.t(i18nkey + 'value_placeholder')}
                required
              />
            </Grid.Column>
            <Grid.Column width={3} verticalAlign="middle">
              <Field
                component={FormCheckbox}
                name="dealers_only"
                label={I18n.t(i18nkey + 'dealers_only')}
              />
              <Fields
                names={['code', 'one_time_code']}
                component={({ code, one_time_code }) => (
                  <FormCheckbox
                    {...one_time_code}
                    label={I18n.t(i18nkey + 'one_time_code')}
                    disabled={!code.input.value}
                  />
                )}
              />
            </Grid.Column>
          </Grid.Row>
          <DiscountDates/>
          <Grid.Row>
            <Grid.Column width={6}>
              <ComponentHeader
                inline
                icon={config.icons.attach}
                title={I18n.t(i18nkey + 'products')}
              />
              <Segment
                attached
                className={classNames(['payload', dark && 'inverted'])}>
                <Table compact size="small" basic="very" className="spaced">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>ArtNr / Bezeichnung</Table.HeaderCell>
                      <Table.HeaderCell collapsing/>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    <FieldArray
                      component={(params) => (
                        <div children={this.getRows(params)}/>
                      )}
                      name="product_ids"
                    />
                  </Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
            <Grid.Column width={6}>
              <ProductBrowser
                {...{
                  inline: true,
                  selectable: 'left',
                  inverted: false,
                  download: false,
                  onSelect: (articleNumber) => this.addProduct(articleNumber),
                  initialValues: {
                    filterActive: true,
                    filterInactive: false,
                    filterArchived: false,
                    filterProduct: true,
                    filterFamily: false,
                    filterFamilyMember: true,
                    filterText: '',
                    categoryFilter: -1,
                  },
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    )
  }
}

DiscountProducts = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountProducts)
export default DiscountProducts



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountProducts.jsx